import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { MapPin } from 'lucide-react';
import { api } from '../lib/api';
import ProductCard from '../components/ProductCard';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../components/ui/accordion';

export default function CityPage() {
  const { citySlug } = useParams();
  const [city, setCity] = useState(null);
  const [products, setProducts] = useState([]);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setCity(null); setNotFound(false);
    api.getCityBySlug(citySlug)
      .then((c) => {
        setCity(c);
        if (c.metaTitle) document.title = c.metaTitle;
      })
      .catch(() => setNotFound(true));
    api.getProducts().then((p) => setProducts(p.slice(0, 4))).catch(() => {});
    return () => { document.title = 'Natur Autoescuela Store'; };
  }, [citySlug]);

  if (notFound) {
    return (
      <div className="max-w-7xl mx-auto px-4 py-24 text-center">
        <p className="text-stone-500 mb-4">Página no encontrada.</p>
        <Link to="/" className="text-teal-600 font-bold">Volver al inicio</Link>
      </div>
    );
  }

  if (!city) return <div className="max-w-7xl mx-auto px-4 py-24 text-center text-stone-400">Cargando…</div>;

  return (
    <div>
      <section className="bg-stone-800 text-white py-16">
        <div className="max-w-7xl mx-auto px-4">
          <p className="flex items-center gap-1.5 text-amber-400 font-bold text-sm mb-3"><MapPin className="w-4 h-4" /> {city.name}</p>
          <h1 className="text-3xl md:text-4xl font-black mb-4" data-testid="city-title">Autoescuela en {city.name}</h1>
          <p className="text-stone-300 max-w-2xl leading-relaxed">{city.content}</p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 py-14">
        <h2 className="text-2xl font-black text-stone-800 mb-8">Productos disponibles en {city.name}</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {products.map((p) => <ProductCard key={p.id} product={p} />)}
        </div>
      </section>

      {(city.faq || []).length > 0 && (
        <section className="max-w-3xl mx-auto px-4 pb-14">
          <h2 className="text-2xl font-black text-stone-800 mb-4">Preguntas frecuentes en {city.name}</h2>
          <Accordion type="single" collapsible>
            {city.faq.map((f, i) => (
              <AccordionItem key={i} value={`cf-${i}`}>
                <AccordionTrigger className="text-sm text-left">{f.q}</AccordionTrigger>
                <AccordionContent className="text-sm text-stone-500">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </section>
      )}

      <section className="max-w-7xl mx-auto px-4 pb-16 text-center">
        <Link to="/tienda" className="btn-natur inline-block px-8 py-3 rounded font-bold text-sm" data-testid="city-cta">Ver toda la tienda</Link>
      </section>
    </div>
  );
}
